import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface TutorialTranslations {
    [lang: string]: string;
}

export interface TutorialPayload {
    title: TutorialTranslations;
    videoUrl: string;
    category: string;
    priority: number;
    active: boolean;
}

export interface TutorialListItem {
    id: string;
    title: string;
    videoUrl: string;
    category: string;
    active: boolean;
    priority: number;
    languageCount: number;
}

export interface TutorialDetail extends TutorialPayload {
    id: string;
}

const COMMANDS = '/sa/sudokuvs/admin/commands';

export class TutorialManagementHandler {
    async getTutorials(): Promise<{ results: TutorialListItem[] }> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/GetAllTutorials`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async getTutorialDetails(tutorialId: string): Promise<TutorialDetail> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/GetTutorialDetails?TutorialId=${encodeURIComponent(tutorialId)}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async createTutorial(payload: TutorialPayload): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/CreateTutorial`;
        const content = JSON.stringify(payload);
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async updateTutorial(tutorialId: string, payload: TutorialPayload): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/UpdateTutorial`;
        const content = JSON.stringify({ tutorialId, ...payload });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async deleteTutorial(tutorialId: string): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/DeleteTutorial`;
        const content = JSON.stringify({ tutorialId });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }
}
